import { Routes } from '@angular/router';

import { ChatComponent } from './chat.component';

export const chatRoutes: Routes = [
  {
    path: '',
    component: ChatComponent,
  },
  {
    path: ':threadId',
    component: ChatComponent,
  },
];
